import WingLeftAd from '@components/ads/Article/WingLeft'
import WingRightAd from '@components/ads/Article/WingRight'
import UIContainer from '@components/ui/UIContainer'
import { Box } from '@mui/joy'
import pxToRem from '@utils/pxToRem'
import { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'

const ArticleWingAds = () => {
	const [fixed, setFixed] = useState<boolean>(false)
	const [footerTop, setFooterTop] = useState<number>(0)
	const onScroll = () => {
		const scrollTop = window.scrollY + 80
		const footerOffset = (document.querySelector('footer')?.offsetTop ?? 0) - 600 - 24
		setFixed(scrollTop >= footerOffset)
		setFooterTop(footerOffset)
	}
	useEffect(() => {
		if (!isMobile) {
			window.addEventListener('scroll', onScroll)
			window.addEventListener('resize', onScroll)
		}
		return () => {
			window.removeEventListener('scroll', onScroll)
		}
	}, [isMobile])
	return (
		<UIContainer
			display={{
				xs: 'none',
				lg: 'block',
			}}
			sx={{
				position: fixed ? 'absolute' : 'sticky',
				top: fixed ? pxToRem(footerTop) : pxToRem(80),
				left: 0,
				right: 0,
				width: {
					xl: pxToRem(1280),
					lg: pxToRem(1024),
				},
				'& iframe': {
					display: 'block',
				},
			}}
		>
			<Box
				sx={{
					position: 'absolute',
					top: pxToRem(24),
					left: {
						lg: pxToRem(36),
						xl: pxToRem(24),
					},
					marginLeft: '-210px',
				}}
			>
				<WingLeftAd />
			</Box>
			<Box
				sx={{
					position: 'absolute',
					top: pxToRem(24),
					right: {
						lg: pxToRem(36),
						xl: pxToRem(24),
					},
					marginRight: '-210px',
				}}
			>
				<WingRightAd />
			</Box>
		</UIContainer>
	)
}
export default ArticleWingAds
